import React from 'react';
import { string } from 'prop-types';
import Desktop from './Desktop/Desktop';
import Mobile from './Mobile/Mobile';

const propTypes = {
  id: string.isRequired
};

const Technology = ({ id }) => {
  const isMobile = window.innerWidth < 992;

  const technologyProps = {
    header: 'Technology',
    content:
      'Technology is a crucial part of any cutting-edge safety plan, and JetSuite is the only light jet operator in' +
      ' the world with In Flight, Real-Time Satellite Weather Mapping and Safe Taxi Technology installed on every' +
      ' plane, ensuring that our pilots have the best, most accurate situational awareness at all times.'
  };

  return isMobile ? (
    <Mobile id={id} technologyProps={technologyProps} />
  ) : (
      <Desktop id={id} technologyProps={technologyProps} />
    );
};

Technology.propTypes = propTypes;

export default Technology;



// WEBPACK FOOTER //
// ./src/components/Safety/Technology/Technology.jsx